// extracted by css-extract-rspack-plugin
export default {"sidebar":"bIgUY","left":"GDORW","right":"OJIQe"};